// import { AxiosInterceptor } from 'navigation/Interceptor';
import './devMockBridge'; // dev/staging test tool, gated on ?mockBridge=1; must precede app graph
import { prefetchAppEntryChunk } from 'pages/AppBridge/appEntryChunks';
import { armBootTrace } from 'utils/bootTrace';
import { FlowProvider } from 'context/SentryTracker/FlowContext';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import PageViewTracker from './context/SentryTracker/PageViewTracker';
import './infrastructure/serviceConfigs/clarityConfig';
import './infrastructure/serviceConfigs/cleverTapConfig';
import './infrastructure/serviceConfigs/sentryConfig';
import './locales/i18n';
import { store } from './store/store';
import { injectPartnerFonts } from './themes/injectPartnerFonts';

// Before render: defines --font-* and the partner's @font-face rules, so the
// first paint already has the right faces and nothing flashes a fallback.
injectPartnerFonts();

// Webview boot: start the destination chunk download before React even mounts,
// so it rides alongside the token + CreateSession round trips. import() of the
// same chunk is idempotent, so this can never double-download.
if (window.location.pathname === '/app-bridge') {
  const redirect =
    new URLSearchParams(window.location.search).get('redirect') || '';
  // Armed before React mounts so JS-eval time lands in the trace too.
  armBootTrace(redirect);
  prefetchAppEntryChunk(redirect);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    {/* <AxiosInterceptor> */}
    <BrowserRouter>
      <FlowProvider store={store}>
        <App />
        <PageViewTracker />
      </FlowProvider>
    </BrowserRouter>
    {/* </AxiosInterceptor> */}
  </Provider>
);
